import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { ScrollText } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Professor.");
      nav("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen paper grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1721702754494-fdd7189f946c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwcHJvZmVzc29ycyUyMHJlc2VhcmNoaW5nJTIwdW5pdmVyc2l0eSUyMGxpYnJhcnl8ZW58MHx8fHwxNzg3NjcyNDM4fDA&ixlib=rb-4.1.0&q=85" className="absolute inset-0 w-full h-full object-cover"/>
        <div className="absolute inset-0 bg-gradient-to-tr from-primary/70 via-black/40 to-black/70"/>
        <div className="relative z-10 h-full flex flex-col p-12 text-white justify-between">
          <Link to="/" className="flex items-center gap-2"><ScrollText className="w-6 h-6"/> <span className="font-display text-2xl">GrantForge</span></Link>
          <div>
            <div className="font-display text-5xl leading-tight max-w-md">A quiet room to write your best proposal.</div>
            <div className="mt-4 max-w-md text-white/80">Sign in and pick up where you left off.</div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="login-form">
          <div>
            <div className="overline">Welcome back</div>
            <h1 className="font-display text-4xl mt-2">Sign in</h1>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="login-password" />
          </div>
          <Button type="submit" className="w-full rounded-full" disabled={loading} data-testid="login-submit-btn">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
          <div className="text-sm text-muted-foreground">
            New here? <Link to="/register" className="text-primary hover:underline" data-testid="link-register">Create an account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
